import * as React from 'react';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import { connect } from 'react-redux';
import RbTextField from '../../../bosch-react/components/text-field/RbTextField';
import { DatePicker } from '@fluentui/react/lib/DatePicker';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import '../../../core/scss/_customize.scss';
import Template from '../../../core/libraries/Template';
import Constants from '../../../core/libraries/Constants';
import { RootState } from '../../../store/store';
import { updateField } from '../actions';
import Helper from '../../../core/libraries/Helper';
import RbCheckbox from '../../../bosch-react/components/checkbox/RbCheckbox';
import CustomizedPeoplePicker from '../../../core/components/PeoplePicker/CustomizedPeoplePicker';
import { PrincipalType } from '../../../core/components/PeoplePicker/types';
import { removeAliasDomain } from '../../../utils/converter';
import { IPersonaProps } from '@fluentui/react';
// import { getConfigurations } from '../services';

interface PropertiesProps {
    commonReport: any,
    updateField: typeof updateField,
    mode: any,
    validation: any,
    RnDReportTypes: any,
    ThesisReportTypes: any,
    PaperReportTypes: any,
    //checkBoxChecked: any,
}

class Properties extends React.Component<PropertiesProps, any> {
    authorsRef: React.RefObject<any> = React.createRef();
    keywordsRef: React.RefObject<any> = React.createRef();

    componentDidMount() {
        if (!!this.keywordsRef.current) {
            this.keywordsRef.current.setValue((!!this.props.commonReport.Keywords) ? this.props.commonReport.Keywords : "");
        }
    }


    constructor(props: PropertiesProps) {
        super(props);
        this.state = {
            paperType: "",
            maximumAuthor: 5, //default
        };

        this.renderTitle = this.renderTitle.bind(this);
        this.renderAuthors = this.renderAuthors.bind(this);
        this.renderDocumentDate = this.renderDocumentDate.bind(this);
        this.renderDocumentNumber = this.renderDocumentNumber.bind(this);
        this.renderProjectNumber = this.renderProjectNumber.bind(this);
        this.renderKeywords = this.renderKeywords.bind(this);
        this.renderProcess = this.renderProcess.bind(this);
        this.renderProduct = this.renderProduct.bind(this);
        this.renderPlant = this.renderPlant.bind(this);
        this.renderIQIS = this.renderIQIS.bind(this);
        this.renderAuthorDisplayName = this.renderAuthorDisplayName.bind(this);
        // this.renderAuthorsMaunalNote =  this.renderAuthorsMaunalNote.bind(this);
        this.renderNameConference = this.renderNameConference.bind(this);
        this.renderLocationConference = this.renderLocationConference.bind(this);
        this.renderDateConference = this.renderDateConference.bind(this);

        this.renderNameJournal = this.renderNameJournal.bind(this);
        this.renderDatePublic = this.renderDatePublic.bind(this);
        this.renderKeywordsNote = this.renderKeywordsNote.bind(this);

        //Render specific box regarding UploadType
        this.renderLL = this.renderLL.bind(this);
        this.renderPaper = this.renderPaper.bind(this);
        this.renderRnD = this.renderRnD.bind(this);
    }
    render() {
        let element: any;
        switch (this.props.commonReport.UploadType) {
            case "RnD": {
                element = this.renderRnD();
                break;
            }
            case "LL": {
                element = this.renderLL();
                break;
            }
            case "Paper": {
                element = this.renderPaper();
                break;
            }
            case "Thesis": {
                break;
            }
        }

        return (
            <React.Fragment>
                {this.renderTitle()}
                {this.renderAuthors()}
                {this.props.commonReport.UploadType !== Constants.UPLOAD_TYPE.Paper && this.renderAuthorDisplayName()}
                {this.renderAuthorDisplayNameNote()}
                {this.renderDocumentDate()}
                {this.renderDocumentType()}
                {element}
            </React.Fragment>

        );
    }
    renderTitle() {
        return Template.renderUploadRowTemplate("Title",
            <RbTextField value={this.props.commonReport.Title}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("Title", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.TITLE, undefined, true, this.props.validation.Title);
    }

    handleOnChangeAuthors = (persona: IPersonaProps[]) => {
        let items = this.authorsRef.current.getSelectedItems();
        console.log(items);
        let results: any[] = [];
        items.forEach((item: any) => {
            !!item.loginName && results.push(removeAliasDomain(item.loginName));
        });
        this.props.updateField("Authors", results);
        this.props.updateField("PreSelectedAuthors", persona);
        this.props.updateField("IsFromCRDivision", !!items.length && items.some((item: any) => item.displayName?.includes("CR/")))
    }

    renderAuthors() {
        return Template.renderUploadRowTemplate(
            "Authors",
            <CustomizedPeoplePicker
                defaultValue={!!this.props.commonReport.PreSelectedAuthors ? this.props.commonReport.PreSelectedAuthors : []}
                principalType={PrincipalType.People}
                componentRef={this.authorsRef}
                itemLimit={10}
                onChange={this.handleOnChangeAuthors}
            />,
            Constants.UPLOAD_INFO_MESSAGE.AUTHORS,
            undefined,
            true,
            this.props.validation.Authors
        );
    }

    renderAuthorDisplayName() {
        const checked = this.props.commonReport.ExternalAuthorAcknowledged;
        return Template.renderUploadRowTemplate(
            "Author display name",
            <div>
                <RbCheckbox
                    checked={checked}
                    label={Constants.EXTERNAL_CONFIRMATION_MESSAGE}
                    onChange={() => {
                        const newValue = !checked;

                        this.props.updateField("ExternalAuthorAcknowledged", newValue);
                        if (newValue) {
                            this.props.updateField("ExternalAuthorConfirmationText", Constants.EXTERNAL_CONFIRMATION_MESSAGE);
                        } else {
                            this.props.updateField("AuthorDisplayName", "");
                            this.props.updateField("ExternalAuthorConfirmationText", "");
                        }
                    }}
                />

                {checked && (
                    <div style={{ marginTop: 10 }}>
                        <RbTextField
                            value={this.props.commonReport.AuthorDisplayName}
                            placeholder="Enter Author display name (non-Bosch)"
                            onChange={(event: React.ChangeEvent<any>) => {
                                this.props.updateField(
                                    "AuthorDisplayName",
                                    event.currentTarget.value
                                );
                            }}
                        />
                    </div>
                )}
            </div>,
            "Only for non-Bosch authors",
            "(Optional)",
            false,
            this.props.validation.AuthorDisplayName
        );
    }

    handleOnChangeDocumentDate = (date: Date | null | undefined) => {
        if (date) {
            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            this.props.updateField("DocumentDate", utcDate);
        } else {
            this.props.updateField("DocumentDate", null);
        }
    }

    renderAuthorDisplayNameNote() {
        const checked = this.props.commonReport.ExternalAuthorAcknowledged;
        if (checked) {
            return Template.renderNoteCustom('Please fill in the author name as text.');
        }
        else {
            return null;
        }

    }

    //---
    renderDocumentDate() {
        const { DocumentDate } = this.props.commonReport
        return Template.renderUploadRowTemplate("Report date",
            <DatePicker value={DocumentDate}
                showGoToToday={false} placeholder="Select a date..."
                onSelectDate={this.handleOnChangeDocumentDate} />,
            Constants.UPLOAD_INFO_MESSAGE.REPORT_DATE, undefined, true, this.props.validation.DocumentDate);
    }

    renderDocumentNumber() {
        return Template.renderUploadRowTemplate("Report number",
            <RbTextField value={this.props.commonReport.DocumentNumber}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("DocumentNumber", event.currentTarget.value); }} />
            , Constants.UPLOAD_INFO_MESSAGE.REPORT_NUMBER, "(Optional)");
    }
    renderProjectNumber() {
        return Template.renderUploadRowTemplate("Project number",
            <RbTextField value={this.props.commonReport.ProjectNumber}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("ProjectNumber", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.PROJECT_NUMBER, "(Optional)");
    }
    renderRnD() {
        return (
            <React.Fragment>
                {this.renderDocumentNumber()}
                {this.renderProjectNumber()}
            </React.Fragment>
        )
    }

    renderDocumentType() {
        let DocumentTypeOptionArr: any[] = [];
        let UploadInfoMsg: string = "";
        switch (this.props.commonReport.UploadType) {
            case "RnD": {
                DocumentTypeOptionArr = this.props.RnDReportTypes;
                UploadInfoMsg = Constants.UPLOAD_INFO_MESSAGE.RND_REPORT_TYPE;
                break;
            }
            case "Thesis": {
                DocumentTypeOptionArr = this.props.ThesisReportTypes;
                UploadInfoMsg = Constants.UPLOAD_INFO_MESSAGE.THESIS_REPORT_TYPE;
                break;
            }
            case "Paper": {
                DocumentTypeOptionArr = this.props.PaperReportTypes;
                UploadInfoMsg = Constants.UPLOAD_INFO_MESSAGE.PAPER_REPORT_TYPE;
                break;
            }
            case "LL": {
                return null;
            }
        }
        return Template.renderUploadRowTemplate("Report Type",
            <Dropdown placeholder="Choose report type" options={DocumentTypeOptionArr}
                selectedKey={this.props.commonReport.DocumentType}
                onChange={(e, selectedOption) => {
                    this.props.updateField("DocumentType", selectedOption?.key);
                    this.setState({ paperType: selectedOption?.key })
                }} />,
            UploadInfoMsg, undefined, true, this.props.validation.DocumentType);
    }
    renderKeywords() {
        return Template.renderUploadRowTemplate("Keywords",
            <RbTextField ref={this.keywordsRef} isMultiple={true} minRows={5} value={this.props.commonReport.Keywords}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("Keywords", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.KEYWORDS, undefined, true, this.props.validation.Keywords);
    }
    renderProcess() {
        return Template.renderUploadRowTemplate("Process",
            <RbTextField disabled={!!this.props.commonReport.Product ? true : false} value={this.props.commonReport.Process}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("Process", event.currentTarget.value); }} />,
            "", undefined, false, this.props.validation.Process);
    }
    renderProduct() {
        return Template.renderUploadRowTemplate("Product",
            <RbTextField disabled={!!this.props.commonReport.Process ? true : false} value={this.props.commonReport.Product}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("Product", event.currentTarget.value); }} />,
            "", undefined, false, this.props.validation.Product);
    }
    renderPlant() {
        return Template.renderUploadRowTemplate("Plant/BU",
            <RbTextField value={this.props.commonReport.PlantorBU}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("PlantorBU", event.currentTarget.value); }} />
            , "", undefined, false, this.props.validation.PlantorBU);
    }
    renderIQIS() {
        return Template.renderUploadRowTemplate("IQIS number",
            <RbTextField value={this.props.commonReport.IQISNumber}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("IQISNumber", event.currentTarget.value); }} />, "", "(Optional)", false);
    }
    renderLL() {
        return (
            <React.Fragment>
                {this.renderProcess()}
                {
                    <div className="ms-Grid">
                        <div className="ms-Grid-row">

                            <div className="ms-Grid-col ms-sm1"></div>
                            <div className="ms-Grid-col ms-sm1"><RbLabel>Or</RbLabel> </div>
                            <div className="ms-Grid-col ms-sm10">

                            </div>
                        </div>
                    </div>
                }
                {this.renderProduct()}
                {this.renderPlant()}
                {this.renderIQIS()}
            </React.Fragment>
        )
    }
    renderKeywordsNote() {
        return Template.renderNote('Please fill in keywords in English. Please separate your keywords via semicolon ";" to make it easier for your colleagues to distinguish the keywords.');
    }
    renderNameConference() {
        return Template.renderUploadRowTemplate("Name of conference",
            <RbTextField value={this.props.commonReport.NameOfConference} key={"c"}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("NameOfConference", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.NAME_CONFERENCE, "", true, this.props.validation.NameOfConference);

    }
    renderLocationConference() {
        return Template.renderUploadRowTemplate("Location of conference",
            <RbTextField value={this.props.commonReport.LocationOfConference}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("LocationOfConference", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.LOCATION_CONFERENCE, "", true, this.props.validation.LocationOfConference);
    }

    handleChangeConferenceDate = (date: Date | undefined | null) => {
        if (date) {
            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            this.props.updateField("DateOfConference", utcDate);
        } else {
            this.props.updateField("DateOfConference", null);
        }
    }

    renderDateConference() {
        return Template.renderUploadRowTemplate("Date of conference",
            <DatePicker value={this.props.commonReport.DateOfConference}
                onSelectDate={this.handleChangeConferenceDate}
                showGoToToday={false} placeholder="Select a date..." formatDate={(data) => Helper.getDateTimeFormatForUI(data)} />,
            Constants.UPLOAD_INFO_MESSAGE.DATE_CONFERENCE, "", true, this.props.validation.DateOfConference);
    }
    renderNameJournal() {
        return Template.renderUploadRowTemplate("Name of journal",
            <RbTextField value={this.props.commonReport.NameOfJournal} key={"j"}
                onChange={(event: React.ChangeEvent<any>) => { this.props.updateField("NameOfJournal", event.currentTarget.value); }} />,
            Constants.UPLOAD_INFO_MESSAGE.NAME_JOURNAL, "", true, this.props.validation.NameOfJournal);
    }

    handleChangePublicDate = (date: Date | undefined | null) => {
        if (date) {
            const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            this.props.updateField("DateOfPublication", utcDate);
        } else {
            this.props.updateField("DateOfPublication", null);
        }
    }

    renderDatePublic() {
        return Template.renderUploadRowTemplate("Date of publication",
            <DatePicker value={this.props.commonReport.DateOfPublication}
                onSelectDate={this.handleChangePublicDate}
                showGoToToday={false} placeholder="Select a date..." formatDate={(data) => Helper.getDateTimeFormatForUI(data)} />,
            Constants.UPLOAD_INFO_MESSAGE.DATE_PUBLICATION, "", true, this.props.validation.DateOfPublication);
    }

    renderPaper() {
        switch (this.props.commonReport.DocumentType) {
            case "Conference Paper": {
                return (
                    <React.Fragment>
                        {this.renderNameConference()}
                        {this.renderLocationConference()}
                        {this.renderDateConference()}
                    </React.Fragment>

                )
            }
            case "Journal Paper": {
                return (
                    <React.Fragment>
                        {this.renderNameJournal()}
                        {this.renderDatePublic()}
                    </React.Fragment>
                )
            }

        }
        return null;
    }
}
const mapStateToProps = (state: RootState) => ({
    commonReport: state.upload.commonReport,
    validation: state.upload.validation,
    mode: state.upload.mode,
    RnDReportTypes: state.upload.RnDReportTypes,
    ThesisReportTypes: state.upload.ThesisReportTypes,
    PaperReportTypes: state.upload.PaperReportTypes,
    //checkBoxChecked: state.upload.checkBoxChecked
});

export default connect(mapStateToProps, { updateField })(Properties);



